export const SET_LOBBY = 'SET_LOBBY';
export const receiveLobby = payload => async dispatch => {
  dispatch({
    type: SET_LOBBY,
    payload
  });
};